export default {
  title: "Staff-Benachrichtigungen",
  description: "Betriebswarnungen, die Staff-Aufmerksamkeit erfordern.",
  empty: {
    title: "Keine Benachrichtigungen",
    description: "Es gibt keine Benachrichtigungen, die Ihren Filtern entsprechen.",
    openOnly: "Derzeit keine offenen Benachrichtigungen.",
  },
  filters: {
    status: "Status",
    severity: "Schweregrad",
    category: "Kategorie",
    any: "Beliebig",
  },
  statusTabs: {
    open: "Offen",
    acknowledged: "Bestätigt",
    resolved: "Gelöst",
    all: "Alle",
  },
  status: {
    open: "Offen",
    acknowledged: "Bestätigt",
    resolved: "Gelöst",
  },
  severity: {
    warning: "Warnung",
    error: "Fehler",
    critical: "Kritisch",
  },
  category: {
    payment: "Zahlung",
    booking: "Buchung",
    receipt: "Beleg",
    scheduler: "Scheduler",
    integration: "Integration",
    support: "Support",
    device: "Gerät",
    unknown: "Sonstige ({{value}})",
  },
  titles: {
    refund: {
      failed: "Erstattung beim Anbieter fehlgeschlagen",
      rejected_handshake_failed: "Erstattung bei Handshake-Ablehnung fehlgeschlagen",
      retry_exhausted:
        "Erstattungs-Wiederholungen erschöpft — manueller Eingriff erforderlich",
    },
    device: {
      low_battery: "Niedriger Akku: {{displayLabel}} ({{batteryLevel}}%)",
      low_battery_kiosk: "Niedriger Akku: Tablet {{kioskName}}",
      low_battery_kiosk_at_house: "Niedriger Akku: Tablet {{kioskName}} in {{houseName}}",
      low_battery_reader: "Niedriger Akku: POS-Leser",
      low_battery_reader_at_house:
        "Niedriger Akku: POS-Leser in {{houseName}}, verknüpft mit Kiosk {{kioskName}}",
      low_battery_reader_linked:
        "Niedriger Akku: POS-Leser verknüpft mit Kiosk {{kioskName}}",
      low_battery_reader_at_house_only: "Niedriger Akku: POS-Leser in {{houseName}}",
    },
    booking: {
      created: "{{activityName}} — {{customerName}}",
      receipt: {
        manual_amount_registered: "Partner hat manuellen Belegbetrag registriert",
      },
    },
    handshake: {
      notification_exhausted: "Handshake-Öffnungsbenachrichtigungen fehlgeschlagen",
      message_blocked: "Handshake-Nachricht blockiert",
    },
    support: {
      ticket: {
        created: "Neues Support-Ticket ({{ticketNumber}})",
        partner_message: "Partner-Antwort auf Ticket {{ticketNumber}}",
        notification_failed:
          "Support-Ticket-Benachrichtigung fehlgeschlagen ({{ticketNumber}})",
      },
    },
    customer_support: {
      chat: {
        message: "Kundensupport-Chat-Nachricht",
      },
    },
    test: {
      receipt: {
        warning: "[dev] Test-Beleg-Warnung",
      },
      refund: {
        failed: "[dev] Erstattung beim Anbieter fehlgeschlagen",
      },
      manual: "Test-Warnung",
    },
  },
  eventTypes: {
    refund: {
      failed: "Erstattung fehlgeschlagen",
      rejected_handshake_failed: "Erstattung bei Handshake-Ablehnung fehlgeschlagen",
      retry_exhausted: "Erstattungs-Wiederholungen erschöpft",
    },
    device: {
      low_battery: "Niedriger Akku",
    },
    booking: {
      created: "Neue Buchung erstellt",
      receipt: {
        manual_amount_registered: "Manueller Belegbetrag registriert",
      },
    },
    handshake: {
      notification_exhausted: "Handshake-Benachrichtigungen fehlgeschlagen",
      message_blocked: "Handshake-Nachricht blockiert",
    },
    support: {
      ticket: {
        created: "Neues Support-Ticket",
        partner_message: "Partner-Ticket-Antwort",
        notification_failed: "Support-Ticket-Benachrichtigung fehlgeschlagen",
      },
    },
    customer_support: {
      chat: {
        message: "Kundensupport-Chat-Nachricht",
      },
    },
    test: {
      receipt: {
        warning: "Test-Beleg-Warnung",
      },
      refund: {
        failed: "Test-Erstattungsfehler",
      },
      manual: "Test-Manual-Benachrichtigung",
    },
  },
  targetTypes: {
    booking: "Buchung",
    external_payment: "Externe Zahlung",
    handshake_session: "Handshake-Sitzung",
    support_ticket: "Support-Ticket",
    customer_support_chat: "Kundensupport-Chat",
    device: "Gerät",
    reader: "Kartenleser",
  },
  details: {
    eventType: "Ereignis",
    serialNumber: "Seriennummer",
    target: "Ziel",
    lastOccurred: "Zuletzt aufgetreten",
  },
  occurrences: "{{count}} Vorkommen",
  groups: {
    today: "Heute",
    yesterday: "Gestern",
    older: "Früher",
  },
  audit: {
    acknowledged: "Bestätigt von {{admin}} am {{date}}",
    resolved: "Gelöst von {{admin}} am {{date}}",
    unknownAdmin: "Unbekanntes Staffmitglied",
  },
  card: {
    expand: "Benachrichtigung erweitern: {{title}}",
    collapse: "Benachrichtigung einklappen: {{title}}",
  },
  bulk: {
    selectAll: "Alle auf dieser Seite auswählen",
    selectOne: "{{title}} auswählen",
    selected: "{{count}} ausgewählt",
    pageCount: "{{count}} auf dieser Seite",
    hint: "Mehrere auswählen, dann gemeinsam bestätigen oder lösen",
    clearSelection: "Auswahl aufheben",
    acknowledge: "Bestätigen",
    resolve: "Lösen",
    acknowledgeSuccess: "{{count}} Benachrichtigungen bestätigt",
    resolveSuccess: "{{count}} Benachrichtigungen gelöst",
    partialError: "{{count}} Aktionen fehlgeschlagen",
  },
  actions: {
    openPayment: "Zahlung öffnen",
    openBooking: "Buchung öffnen",
    openHandshake: "Handshake öffnen",
    openTicket: "Ticket öffnen",
    openChat: "Chat öffnen",
    openDevice: "Zum Gerät",
    openStructure: "Zur Struktur",
    noLinks: "Keine verknüpfte Ressource",
    acknowledge: "Bestätigen",
    resolve: "Lösen",
    reopen: "Wiedereröffnen",
    acknowledgeSuccess: "Benachrichtigung bestätigt",
    resolveSuccess: "Benachrichtigung gelöst",
    reopenSuccess: "Benachrichtigung wiedereröffnet",
    acknowledgeError: "Bestätigung fehlgeschlagen",
    resolveError: "Lösen fehlgeschlagen",
    reopenError: "Wiedereröffnen fehlgeschlagen",
  },
  pagination: "Seite {{page}} von {{totalPages}} ({{total}} gesamt)",
  paginationSingle_one: "{{count}} Benachrichtigung",
  paginationSingle_other: "{{count}} Benachrichtigungen",
} as const;
